<div class="overlay">
  <div class="overlay-spinner">
    <yat-icon id="a66fac48-8e91-4b2c-be9a-ba30c65b5baf" name="loader-light" class="spinner"></yat-icon>
  </div>
</div>
